<template>
  <div class="row mx-0 ">
    <CustomModal
      v-model="confirmDelete"
      save-text="Si"
      cancel-text="No"
      title="Confirmación"
      @cancel="closeModals"
      @save="deleteComment"
    >
      <div class="text-center">
        ¿Está seguro que desea eliminar el comentario?
      </div>
    </CustomModal>
    <CustomModal
      v-model="showCantDelete"
      save-text="Ok"
      cancel-text="Cerrar"
      title="Comentario"
      @cancel="closeModals"
      @save="closeModals"
    >
      <div class="text-center">
        No se pueden eliminar comentarios que estan relacionados con un
        estudiante.
      </div>
    </CustomModal>

    <div class="col-md-12">
      <div
        v-for="(child, childIndex) in rows"
        :key="`child-row-${childIndex}`"
        class="row comment__container"
      >
        <div class="col-md-2">
          <div>
            <div class="mb-4">
              <span class="item-title">Módulo:</span>
              <br />
              <span class="item-text">{{ child.moduleName }}</span>
            </div>

            <div class="mb-4">
              <span class="item-title">Categoría:</span>
              <br />
              <span class="item-text">{{ child.category }}</span>
              <br />
              <span class="item-text">{{ child.commentId }}</span>
            </div>

            <div class="mb-4">
              <span class="item-title">Fecha:</span>
              <br />
              <span class="item-text">{{ child.date | date }}</span>
              <br />
              <span class="item-text-hours">{{ child.createdOn | hour }}</span>
            </div>
          </div>
        </div>

        <div
          class="col-md-10"
          style="border-left: 1px solid #E2E2E2; padding-left: 30px;"
        >
          <div class="row audit-detail__container">
            <div class="col-md-4">
              <span class="item-title">Añadido por:</span>
              <br />
              <span class="item-text">{{ child.createdBy }}</span>
            </div>

            <div class="col-md-4">
              <span class="item-title">Modificación</span>
              <br />
              <span class="item-text">{{ child.updatedOn }}</span>
            </div>

            <div class="col-md-4">
              <div class="custom-dropdown-container">
                <button
                  v-if="child.showAction"
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a
                    v-if="hasEditPermission"
                    class="drop-item cursor-pointer"
                    @click="goToEditCommet(child.commentId)"
                  >
                    <i class="fas fa-pencil text-green pr-2" />
                    <span>Editar</span>
                  </a>
                  <a
                    v-if="child.documentId"
                    class="drop-item cursor-pointer"
                    @click="downloadAttachment(child.documentId)"
                  >
                    <i class="fas fa-file-download text-green pr-2" />
                    <span>Descargar Documento</span>
                  </a>
                  <a
                    v-if="
                      (child.canDelete || hasDeletePermission) &&
                        IsCategoryDeletable(child.categoryType)
                    "
                    class="drop-item cursor-pointer"
                    @click="showDeleteConfirmation(child.commentId)"
                  >
                    <i class="fas fa-times-circle text-red pr-2" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div style="margin-left: -10px;">
            <span class="item-title">Comentario:</span>
            <p class="item-text">{{ child.description }}</p>
          </div>
        </div>
      </div>

      <custom-result-not-found v-if="rows.length == 0" />

      <div class="row" v-if="pagination.totalItemCount >= defaultPageSize">
        <div class="col-1 pt-4">
          <custom-drop-down
            v-model="perPage"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="pagingList"
            @input="onPageSizeChanged"
          />
        </div>
        <div class="col-11">
          <pagination
            :data="pagination"
            :page-size="perPage.id"
            @pagination-go-page="onPageChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomModal from '@/components/common/CustomModal';

import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import moment from 'moment';

import Pagination from '@/components/common/Pagination.vue';
import CustomDropDown from 'custom-drop-down';

import CustomResultNotFound from 'custom-result-not-found';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import documentsService from '@/services/documents';
import commentTypes from '@/utils/constants/comment/commentTypes';

const DEFAULT_PAGE_SIZE = 10;

export default {
  name: 'CommentList',
  mixins: [alert],
  components: {
    CustomModal,
    CustomResultNotFound,
    TimeLine,
    TimeLineItem,
    Pagination,
    CustomDropDown,
  },
  data() {
    return {
      showCantDelete: false,
      confirmDelete: false,
      currentComment: null,
      rows: [],
      defaultPageSize: DEFAULT_PAGE_SIZE,
      moveToFirstPage: false,
      perPage: {
        id: DEFAULT_PAGE_SIZE,
        name: DEFAULT_PAGE_SIZE,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      pagingList: [
        {
          id: 10,
          name: 10,
        },
        {
          id: 15,
          name: 15,
        },
        {
          id: 20,
          name: 20,
        },
        {
          id: 25,
          name: 25,
        },
        {
          id: 30,
          name: 30,
        },
      ],
    };
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasEditPermission() {
      return this.$store.getters.HasPermission('student.comment.edit');
    },
    hasDeletePermission() {
      return this.$store.getters.HasPermission('comment.delete');
    },
  },
  methods: {
    IsCategoryDeletable(categoryType) {
      const nonDeletableCategories = [
        commentTypes.RegistroComentarioInactividad,
        commentTypes.RegistroSeguimiento,
        commentTypes.EgresoEliminarEgreso,
        commentTypes.RegistroReactivacion,
      ];
      return !nonDeletableCategories.some((id) => id === categoryType);
    },
    goToEditCommet(commentId) {
      this.$router.push(`/student/comments/edit/${commentId}`);
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    formatDateAudit(date) {
      return moment(date)
        .locale('es')
        .format('DD/MM/YYYY h:mm:ss a');
    },
    async getHistory() {
      const academicYearId =
        this.filters.AcademicYear?.id ?? this.filters.AcademicYear;
      const studentSieParam = `studentSieId=${store.getters['$_student/StudentSie']}`;
      const academicYearParam = `academicYearId=${academicYearId || null}`;
      const moduleParam = `moduleId=${this.filters.ModuleId || null}`;
      const categoryParam = `categoryTypeId=${this.filters.CategoryTypeId ||
        null}`;
      const fromDateParam = `startDate=${
        this.filters.StartDate
          ? new Date(this.filters.StartDate).toISOString()
          : null
      }`;
      const toDateParam = `endDate=${
        this.filters.EndDate
          ? new Date(this.filters.EndDate).toISOString()
          : null
      }`;
      const pageNumberParam = `pageNumber=${
        this.moveToFirstPage ? 1 : this.pagination.currentPage
      }`;
      const pageSizeParam = `pageSize=${this.perPage.id}`;

      this.moveToFirstPage = false;
      try {
        const res = await this.$ApiGet(
          `/api/student/gethistorycomments?${studentSieParam}&${academicYearParam}&${moduleParam}&${categoryParam}&${fromDateParam}&${toDateParam}&${pageNumberParam}&${pageSizeParam}`
        );

        this.rows = res.data.data ? this.formatData(res.data.data) : [];
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      } catch (err) {
        this.response = err;
      }
    },
    formatData(data) {
      const rows = data.map((element) => ({
        commentId: element.commentId,
        moduleName: element.moduleName,
        academicYear: element.academicYearDescription,
        category: element.category,
        description: element.description,
        studentSieId: element.studentSieId,
        date: element.date,
        createdOn: element.createdDate,
        createdOnStr: this.formatDateAudit(element.createdDate),
        createdBy: element.createByFullName,
        updatedOn: element.updatedDate
          ? this.formatDateAudit(element.updatedDate)
          : '-',
        updatedBy: element.modifyByFullName,
        showAction: true,
        categoryType: element.categoryType,
        canDelete: element.canDelete,
        fromParentPortalFlag: element.fromParentPortalFlag,
        documentId: element.documentId,
      }));

      return rows;
    },
    async onPageSizeChanged(perPage) {
      this.perPage = { ...perPage };
      this.pagination.perPage = perPage.id;
      this.moveToFirstPage = true;
      await this.getHistory();
    },

    async onPageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      await this.getHistory();
    },

    async showDeleteConfirmation(CommentId) {
      await alert.methods
        .ShowCancelModal(
          'Atención',
          '¿Está seguro que desea eliminar este registro de comentario?',
          'Sí',
          'No'
        )
        .then((answer) => {
          if (answer) {
            this.deleteComment(CommentId);
          }
        });
    },

    async deleteComment(CommentId) {
      if (this.currentComment === null) {
        this.$ApiDelete('/api/student/deletecomment?commentId=' + CommentId)
          .then(async () => {
            await this.getHistory();
            this.ShowToast(
              'Proceso Exitoso',
              'El comentario fue elminado correctamente.',
              'success'
            );
          })
          .catch((err) => {
            this.cancel();
            this.response = err;
          });
        return;
      }

      this.closeModals();
    },

    closeModals() {
      this.currentComment = null;
      this.showCantDelete = false;
      this.confirmDelete = false;
    },
    downloadAttachment(attachmentId) {
      return documentsService.downloadFromServer(attachmentId);
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(val) {
        this.moveToFirstPage = true;
      },
    },
  },
};
</script>

<style scoped>
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.table {
  margin: 0;
}

.comment {
  position: absolute;
}
.expanded {
  font-size: 14px;
  max-width: 400px;
}

.custom-dropdown-container {
  text-align: right;
  margin-right: 10px;
}
.vgt-row-header {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

.header {
  height: 54px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
}

.subheader {
  padding-left: 20px;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
  border-bottom: 1px solid #e0e2e9;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.subheader-custom {
  height: 52px !important;
  padding-left: 20px;
  background: #e7ebe9 0% 0% no-repeat padding-box;
  font-weight: bold;
}

.comment__container {
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: #f4f6f3;
}

.audit-detail__container {
  border-radius: 5px;
  background-color: #ffffff;
  padding: 10px 5px;
  margin-bottom: 20px;
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #727272;
}

.item-text {
  font-size: 16px;
  font-weight: 700;
  color: #11291b;
}

.item-text-hours {
  font-size: 12px;
  font-weight: 500;
  color: #11291b;
}
</style>
